

export default {
  "localhost": {
      "client_id": "0oa2fysd8vTUjeyAK357",
      "auth_uri": "https://dev-334348.okta.com/oauth2/default/v1/authorize",
      "token_uri": "https://dev-334348.okta.com/oauth2/default/v1/token",
      "issuer": "https://dev-334348.okta.com",
      "userinfo_uri": "https://dev-334348.okta.com/oauth2/default/userinfo",
      "redirect_uri":  window.location.origin + '/implicit/callback',
      "redirectUri": window.location.origin + '/implicit/callback',
      "ga_tracker":'UA-120334913-14'
    },
    "vpi-dev.intuitive.com": {
        "client_id": "0oa1gizs3huV6Ec3g1d8",
        "auth_uri": "https://intusurg.okta.com/oauth2/v1/authorize",
        "token_uri": "https://intusurg.okta.com/oauth2/v1/token",
        "issuer": "https://intusurg.okta.com",
        "userinfo_uri": "https://intusurg.okta.com/oauth2/v1/userinfo",
        "redirect_uri":  window.location.origin + '/implicit/callback',
        "redirectUri": window.location.origin + '/implicit/callback',
        "ga_tracker":'UA-120334913-14'
      },
      "10.83.235.101": {
        "client_id": "0oa1gizs3huV6Ec3g1d8",
        "auth_uri": "https://intusurg.okta.com/oauth2/v1/authorize",
        "token_uri": "https://intusurg.okta.com/oauth2/v1/token",
        "issuer": "https://intusurg.okta.com",
        "userinfo_uri": "https://intusurg.okta.com/oauth2/v1/userinfo",
        "redirect_uri":  window.location.origin + '/implicit/callback',
        "redirectUri": window.location.origin + '/implicit/callback',
        "ga_tracker":'UA-120334913-14'
      },
      "vpi-training.intuitive.com": {
        "client_id": "0oa1j2m7jzkBGSy8w1d8",
        "auth_uri": "https://intusurg.okta.com/oauth2/v1/authorize",
        "token_uri": "https://intusurg.okta.com/oauth2/v1/token",
        "issuer": "https://intusurg.okta.com",
        "userinfo_uri": "https://intusurg.okta.com/oauth2/v1/userinfo",
        "redirect_uri":  window.location.origin + '/implicit/callback',
        "redirectUri": window.location.origin + '/implicit/callback',
        "ga_tracker":'UA-120334913-14'



      },
      "vpi-uat.intuitive.com": {
        "client_id": "0oa1hfdfk2ytaciVJ1d8",
        "auth_uri": "https://intusurg.okta.com/oauth2/v1/authorize",
        "token_uri": "https://intusurg.okta.com/oauth2/v1/token",
        "issuer": "https://intusurg.okta.com",
        "userinfo_uri": "https://intusurg.okta.com/oauth2/v1/userinfo",
        "redirect_uri":  window.location.origin + '/implicit/callback',
        "redirectUri": window.location.origin + '/implicit/callback',
        "ga_tracker":'UA-120334913-14'
      },
      "vpi.intuitive.com": {
        "client_id": "0oa1hoprsxhhqp50b1d8",
        "auth_uri": "https://intusurg.okta.com/oauth2/v1/authorize",
        "token_uri": "https://intusurg.okta.com/oauth2/v1/token",
        "issuer": "https://intusurg.okta.com",
        "userinfo_uri": "https://intusurg.okta.com/oauth2/v1/userinfo",
        "redirect_uri":  window.location.origin + '/implicit/callback',
        "redirectUri": window.location.origin + '/implicit/callback',
        "ga_tracker":'UA-120334913-14'
      }
};
